import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledBordered = styled(Flexer.Child)`
  ${(props) => (props.showBorder ? `border-right: 1px solid var(--greyMouse);` : '')}
`;

export { StyledBordered };
